import { FormItemType } from '../enums';
import { FormConfig, FormLayout } from '../types';

export function isHidden(id: keyof FormLayout, { formElements }: FormConfig) {
	const { hidden, type } = formElements[id];
	const hiddenTypes: Array<string> = [FormItemType.HiddenInput];

	return hiddenTypes.includes(type) || !!hidden;
}
